import React, { useState } from 'react'
import { Faq, FaqBody, FaqHead, FaqRow, PageWrapper } from '../Community/styled'
import iconUp from '../../assets/svg/arrow-up-wh.svg'
import iconDown from '../../assets/svg/arrow-down-wh.svg'

const faq = [
  {
    q: '1. What is APTM Dex?',
    a:
      'APTM Dex is a decentralized exchange (DEX) that allows users to trade cryptocurrencies directly from their wallets without the need for intermediaries. It operates on the Apertum blockchain using an automated market maker (AMM) model, enabling seamless and permissionless token swaps.'
  },
  {
    q: '2. How does APTM Dex work?',
    a:
      'APTM Dex uses liquidity pools instead of traditional order books. Users provide liquidity by depositing tokens into these pools, and the platform utilizes a mathematical formula to determine prices based on supply and demand. Swaps occur automatically through smart contracts.'
  },
  {
    q: '3. What are liquidity providers, and how do they earn rewards?',
    a:
      "Liquidity providers (LPs) deposit pairs of tokens into APTM Dex's liquidity pools. In return, they receive LP tokens, which represent their share of the pool. LPs earn rewards from a portion of the trading fees generated when users swap tokens within the pool."
  },
  {
    q: '4. What are liquidity pools on APTM Dex?',
    a:
      'Liquidity pools are smart contract-based reserves of token pairs that enable decentralized trading on APTM Dex. Instead of relying on traditional buyers and sellers to match orders, liquidity pools automatically facilitate token swaps using an Automated Market Maker (AMM) model. \n When users trade on APTM Dex, they interact directly with liquidity pools rather than a traditional order book. These pools are funded by Liquidity Providers (LPs) who deposit token pairs into the smart contract.'
  },
  {
    q: '5. How do Liquidity Providers contribute to the ecosystem?',
    a:
      'Liquidity Providers (LPs) deposit equal values of two tokens (e.g., APTM/USDT) into a liquidity pool. In return, they receive LP tokens, which represent their share of the pool. \n Whenever someone swaps tokens within that pool, a small trading fee is collected. This fee is then distributed proportionally among LPs, allowing them to earn passive income from their contributions.'
  },
  {
    q: '6. What are the benefits of becoming a Liquidity Provider on APTM Dex?',
    a:
      'Liquidity providers play a crucial role in the decentralized finance (DeFi) ecosystem and enjoy several benefits:',
    l: [
      {
        text:
          'Earn Trading Fees – Every transaction in the pool generates a small fee, which is distributed to LPs based on their share of the pool. The more trading activity in the pool, the higher the potential rewards.'
      },
      {
        text:
          'Passive Income Generation – LPs can earn passive income without actively trading, simply by providing liquidity.'
      },
      {
        text:
          'Decentralized & Permissionless Participation – Anyone can become an LP without needing approval from intermediaries. All that’s required is a compatible Apertum blockchain wallet and tokens for deposit.'
      },
      {
        text:
          'Supporting Market Efficiency – By adding liquidity, LPs help reduce price slippage, ensuring that users can trade with minimal impact on price.'
      },
      {
        text:
          'Passive Income Generation – LPs can earn passive income without actively trading, simply by providing liquidity.'
      }
    ]
  },
  {
    q: '7. Are there any risks involved in providing liquidity?',
    a: 'While providing liquidity can be profitable, there are risks to consider:',
    l: [
      {
        text:
          'Impermanent Loss – If the price of deposited tokens changes significantly, the total value of LP holdings may be lower compared to simply holding the tokens outside the pool.'
      },
      {
        text:
          'Low Trading Volume Risk – If a pool has low trading activity, the rewards from trading fees may be insufficient to offset potential impermanent losses.'
      },
      {
        text:
          'Smart Contract Risks – Although APTM Dex’s smart contracts are built securely, DeFi platforms are still susceptible to potential bugs or exploits.'
      }
    ]
  },
  {
    q: '8. How do I become a Liquidity Provider on APTM Dex?',
    a: 'To add liquidity to APTM Dex and start earning rewards:',
    l: [
      { text: 'Connect your wallet – Use an Apertum-compatible wallet like MetaMask.' },
      { text: 'Select a trading pair – Choose two tokens you want to provide liquidity for (e.g., APTM/USDT).' },
      {
        text:
          'Deposit an equal value of both tokens – The system requires you to deposit an equivalent USD value of both assets to maintain the 50/50 balance.'
      },
      {
        text:
          'Receive LP tokens – Once deposited, you’ll receive LP tokens representing your share of the liquidity pool.'
      },
      { text: 'Earn trading fees – As users swap tokens in the pool, you earn a portion of the fees.' },
      {
        text:
          'Withdraw anytime – You can remove your liquidity at any time, though keep in mind potential impermanent loss.'
      }
    ]
  },
  {
    q: '9. What are the risks of using APTM Dex?',
    a: 'While APTM Dex is decentralized and non-custodial, there are risks, including:',
    l: [
      { text: 'Impermanent loss: A potential loss compared to holding assets outside a liquidity pool.' },
      { text: 'Smart contract vulnerabilities: Although APTM Dex is audited, all DeFi platforms carry risks.' },
      { text: 'Slippage and price impact: Trades can be affected by large orders or low liquidity in certain pools.' }
    ]
  },
  {
    q: '10. How do I use APTM Dex to swap tokens?',
    a: 'To swap tokens on APTM Dex, follow these steps:',
    l: [
      { text: 'Connect your Apertum-compatible wallet.' },
      { text: 'Select the token you want to swap and the token you want to receive.' },
      { text: 'Enter the amount and review the estimated price, fees, and slippage.' },
      { text: 'Confirm the transaction and approve it in your wallet.' },
      { text: 'Wait for the transaction to be processed on the Apertum blockchain.' }
    ]
  },
  {
    q: '11. What is Impermanent Loss?',
    a:
      'Impermanent loss occurs when the value of your assets in a liquidity pool changes compared to simply holding them in your wallet. This happens because automated market makers (AMMs) like APTM Dex adjust token prices based on supply and demand, which can lead to losses if the token prices move significantly.'
  },
  {
    q: '12. Why is it called ‘Impermanent’ Loss?',
    a:
      'The loss is considered “impermanent” because it only becomes permanent if you withdraw your liquidity while the price difference still exists. If token prices return to their original ratio, the loss disappears. However, if the price shift remains, the loss becomes permanent once liquidity is removed.'
  },
  {
    q: '13. How does Impermanent Loss happen?',
    a:
      "When you provide liquidity on APTM Dex, you deposit two tokens in a 50/50 ratio (e.g., APTM and USDT). If one token's price increases relative to the other, the smart contract automatically adjusts the pool's balance, meaning you end up with more of the lower-value token and less of the higher-value token when you withdraw. This can result in a lower total value compared to simply holding the tokens."
  },
  {
    q: '14. Can Impermanent Loss be avoided?',
    a: 'Impermanent loss can’t be fully avoided but can be minimized by:',
    l: [
      { text: 'Providing liquidity for stablecoin pairs (e.g., USDT/APTM), which have minimal price volatility.' },
      { text: 'Choosing high-volume, low-volatility token pairs.' },
      {
        text:
          'Factoring in trading fees, as liquidity providers earn fees on every swap, which can help offset potential impermanent losses.'
      }
    ]
  },
  {
    q: '15. When does Impermanent Loss become a real loss?',
    a:
      'Impermanent loss becomes a real loss if you withdraw your liquidity while prices are still imbalanced. However, if trading fees earned from the liquidity pool compensate for the impermanent loss, you may still profit despite the price changes.'
  }
]

export default function FaqPage() {
  const [faqOpen, setFaqOpen] = useState<number | null>(null)

  const handleFaqClick = (i: number) => {
    setFaqOpen(faqOpen === i ? null : i)
  }

  return (
    <PageWrapper>
      <Faq>
        {faq.map(({ q, a, l }, i) => (
          <FaqRow key={i} onClick={() => handleFaqClick(i)}>
            <FaqHead>
              {q}
              <img src={faqOpen === i ? iconUp : iconDown} alt="toggle" />
            </FaqHead>
            {faqOpen === i && (
              <FaqBody>
                {a.split('\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
                {l && (
                  <ul>
                    {l.map((item, index) => (
                      <li key={index}>{item.text}</li>
                    ))}
                  </ul>
                )}
              </FaqBody>
            )}
          </FaqRow>
        ))}
      </Faq>
    </PageWrapper>
  )
}
